var _a;
import { default as SiteHeaderMobile } from './SiteHeaderMobile';
import { default as SiteHeaderMobileV2 } from './SiteHeaderMobileV2';
import SiteHeaderContainer from '../SiteHeader.container';
import { withFeatureBranch } from '../../redux/flags';
import { FEATURE_MOBILE_NOTIFICATIONS_HEADER } from '../../features';
export default withFeatureBranch((_a = {},
    _a[FEATURE_MOBILE_NOTIFICATIONS_HEADER] = SiteHeaderContainer(SiteHeaderMobileV2),
    _a))(SiteHeaderContainer(SiteHeaderMobile));
//# sourceMappingURL=index.js.map